/* eslint-disable */
export const updateObject = (oldObject, newProperties) => {
    return {
        ...oldObject,
        ...newProperties
    }
};

export const guid = () => {
    return s4() + s4();
};

const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};

export const checkValidity = (value, rules) => {
    let isValid = true;
    const dateRegex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;


    if (rules.required) {
        if (!value) return false;
        isValid = value.trim() !== '' && isValid;
    }

    if (rules.min) {
        const isDate = dateRegex.test(value);
        if (isDate) {
            const minimumDate = new Date(rules.max);
            const enteredDate = new Date(value);

            isValid = (enteredDate >= minimumDate) && isValid;
        }
        isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.max) {
        const isDate = dateRegex.test(value);
        if (isDate) {
            const currentDate = new Date(rules.max);
            const enteredDate = new Date(value);

            isValid = (enteredDate <= currentDate) && isValid;
        } else {
            isValid = value.length <= rules.maxLength && isValid;
        }
    }

    if (rules.invalidOption) {
        isValid = value.trim() !== rules.invalidOption && isValid;
    }

    if (rules.email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        isValid = re.test(value);
    }

    return isValid;
};

export const generateValidityMessage = (value, rules, isValid) => {
    let errorMessage = '';
    const dateRegex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

    if (rules.required && !isValid) {
        errorMessage = "This field is required";
    }

    if (rules.min && !isValid) {
        if (isDate) {
            errorMessage = `Invalid date: Date entered is before ${rules.min}`
        } else {
            errorMessage = `This field should have a minimum of ${rules.min} characters`;
        }
    }

    if (rules.max && !isValid) {
        const isDate = dateRegex.test(value);
        if (isDate) {
            errorMessage = 'Invalid date: Date entered is after current date.'
        } else {
            errorMessage = `This field should have a maximum of ${rules.max} characters`;
        }
    }

    if (rules.invalidOption && !isValid) {
        errorMessage = "Please select a valid option";
    }

    if (rules.email && !isValid) {
        errorMessage = "Enter a valid email address"
    }

    return errorMessage;
};

export const escapeRegexCharacters = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const formatBytes = (bytes, decimals) => {
    if (bytes === 0) return '0 Bytes';
    let k = 1024,
        dm = decimals || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const inputTypes = {
    TEXT: "text",
    TEXTAREA: "textarea",
    FILE: "file"
}

export const fieldElementTypes = {
    INPUT: "input",
    SELECT: "select",
    CHECKBOX: "checkbox",
    RADIO: "radio"
} 


// WEBPACK FOOTER //
// ./src/components/shared/utility.js